import { createFileRoute, redirect } from '@tanstack/react-router';

import { branchPath } from '@/features/organization-locations/branch-path';

/** Retired image-only gallery. Keep old links on the unified masonry gallery. */
export const Route = createFileRoute(
  '/_authed/dashboard/l/$locationId/marketing/gallery/images'
)({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: branchPath(params.locationId, '/marketing/gallery'),
    });
  },
});
